import { Flex, Text } from "@unifize/sarah";

type AlertMessageProps = {
  type: "success" | "error";
  message: string;
};

const AlertMessage = ({ type, message }: AlertMessageProps) => {
  const styles =
    type === "success"
      ? {
          backgroundColor: "#D1FAE5",
          border: "1px solid #6EE7B7",
          color: "#065F46",
        }
      : {
          backgroundColor: "#FEE2E2",
          border: "1px solid #FCA5A5",
          color: "#991B1B",
        };

  return (
    <Flex
      direction="column"
      gap="0.25rem"
      items="flex-start"
      style={{
        ...styles,
        borderRadius: "0.5rem",
        padding: "1rem 1.25rem",
        marginBottom: "2rem",
      }}
    >
      <Text variant="body" weight="bold" color={styles.color}>
        {type === "success" ? "Success!" : "Error:"}
      </Text>
      <Text variant="body" weight="regular" color={styles.color}>
        {message}
      </Text>
    </Flex>
  );
};

export default AlertMessage;
